export const accountValidationRules = (values) => {
  const errors = {};
  const ifsc = values.meta?.ifscCode?.trim();
  const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
  const accountNumber = values.meta?.accountNumber?.trim();
  const accountNumberRegex = /^\d{9,18}$/;

  if (!values.name) errors.name = "Account name is required";
  else if (values.name.length < 5) errors.name = "Account name must be at least 5 characters";
  if (!values.type || values.type.trim() === "") errors.type = "Account type is required";
  if (ifsc && !ifscRegex.test(ifsc)) errors.meta = { ...errors.meta, ifscCode: "Invalid IFSC Code format" };
  if (accountNumber && !accountNumberRegex.test(accountNumber)) {
    errors.meta = {
      ...errors.meta,
      accountNumber: "Account number must be 9 to 18 digits",
    };
  }

  return errors;
};
